"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SliceTupleIndex = exports.SliceStackingName = exports.SliceStacking = exports.SliceHeaderShift = exports.SliceHeaderMask = exports.SliceTypeName = exports.CursorAnchor = void 0;
/**
 * Specifies whether the start or the end of the cursor is the "anchor", e.g.
 * the end which does not move when user changes selection. The other
 * end is free to move, the moving end of the cursor is "focus". By default
 * "anchor" is usually the start of the cursor.
 */
var CursorAnchor;
(function (CursorAnchor) {
    CursorAnchor[CursorAnchor["Start"] = 0] = "Start";
    CursorAnchor[CursorAnchor["End"] = 1] = "End";
})(CursorAnchor || (exports.CursorAnchor = CursorAnchor = {}));
/**
 * All type name must be fully lowercase, as HTML custom element tag names must
 * be lowercase.
 */
var SliceTypeName;
(function (SliceTypeName) {
    SliceTypeName[SliceTypeName["p"] = 0] = "p";
    SliceTypeName[SliceTypeName["blockquote"] = 1] = "blockquote";
    SliceTypeName[SliceTypeName["codeblock"] = 2] = "codeblock";
    SliceTypeName[SliceTypeName["code-block"] = 3] = "code-block";
    SliceTypeName[SliceTypeName["code_block"] = 4] = "code_block";
    SliceTypeName[SliceTypeName["pre"] = 5] = "pre";
    SliceTypeName[SliceTypeName["ul"] = 6] = "ul";
    SliceTypeName[SliceTypeName["ol"] = 7] = "ol";
    SliceTypeName[SliceTypeName["tl"] = 8] = "tl";
    SliceTypeName[SliceTypeName["li"] = 9] = "li";
    SliceTypeName[SliceTypeName["list"] = 10] = "list";
    SliceTypeName[SliceTypeName["h1"] = 11] = "h1";
    SliceTypeName[SliceTypeName["h2"] = 12] = "h2";
    SliceTypeName[SliceTypeName["h3"] = 13] = "h3";
    SliceTypeName[SliceTypeName["h4"] = 14] = "h4";
    SliceTypeName[SliceTypeName["h5"] = 15] = "h5";
    SliceTypeName[SliceTypeName["h6"] = 16] = "h6";
    SliceTypeName[SliceTypeName["heading"] = 17] = "heading";
    SliceTypeName[SliceTypeName["header"] = 18] = "header";
    SliceTypeName[SliceTypeName["title"] = 19] = "title";
    SliceTypeName[SliceTypeName["subtitle"] = 20] = "subtitle";
    SliceTypeName[SliceTypeName["br"] = 21] = "br";
    SliceTypeName[SliceTypeName["hard_break"] = 22] = "hard_break";
    SliceTypeName[SliceTypeName["nl"] = 23] = "nl";
    SliceTypeName[SliceTypeName["hr"] = 24] = "hr";
    SliceTypeName[SliceTypeName["horizontal_rule"] = 25] = "horizontal_rule";
    SliceTypeName[SliceTypeName["page"] = 26] = "page";
    SliceTypeName[SliceTypeName["aside"] = 27] = "aside";
    SliceTypeName[SliceTypeName["imgblock"] = 28] = "imgblock";
    SliceTypeName[SliceTypeName["embed"] = 29] = "embed";
    SliceTypeName[SliceTypeName["column"] = 30] = "column";
    SliceTypeName[SliceTypeName["contents"] = 31] = "contents";
    SliceTypeName[SliceTypeName["table"] = 32] = "table";
    SliceTypeName[SliceTypeName["tr"] = 33] = "tr";
    SliceTypeName[SliceTypeName["td"] = 34] = "td";
    SliceTypeName[SliceTypeName["cl"] = 35] = "cl";
    SliceTypeName[SliceTypeName["collapse"] = 36] = "collapse";
    SliceTypeName[SliceTypeName["note"] = 37] = "note";
    SliceTypeName[SliceTypeName["mathblock"] = 38] = "mathblock";
    SliceTypeName[SliceTypeName["div"] = 39] = "div";
    SliceTypeName[SliceTypeName["Cursor"] = -1] = "Cursor";
    SliceTypeName[SliceTypeName["RemoteCursor"] = -2] = "RemoteCursor";
    SliceTypeName[SliceTypeName["b"] = -3] = "b";
    SliceTypeName[SliceTypeName["bold"] = -4] = "bold";
    SliceTypeName[SliceTypeName["strong"] = -5] = "strong";
    SliceTypeName[SliceTypeName["i"] = -6] = "i";
    SliceTypeName[SliceTypeName["italic"] = -7] = "italic";
    SliceTypeName[SliceTypeName["em"] = -8] = "em";
    SliceTypeName[SliceTypeName["u"] = -9] = "u";
    SliceTypeName[SliceTypeName["underline"] = -10] = "underline";
    SliceTypeName[SliceTypeName["overline"] = -11] = "overline";
    SliceTypeName[SliceTypeName["s"] = -12] = "s";
    SliceTypeName[SliceTypeName["strike"] = -13] = "strike";
    SliceTypeName[SliceTypeName["strikethrough"] = -14] = "strikethrough";
    SliceTypeName[SliceTypeName["code"] = -15] = "code";
    SliceTypeName[SliceTypeName["mark"] = -16] = "mark";
    SliceTypeName[SliceTypeName["a"] = -17] = "a";
    SliceTypeName[SliceTypeName["link"] = -18] = "link";
    SliceTypeName[SliceTypeName["img"] = -19] = "img";
    SliceTypeName[SliceTypeName["image"] = -20] = "image";
    SliceTypeName[SliceTypeName["comment"] = -21] = "comment";
    SliceTypeName[SliceTypeName["del"] = -22] = "del";
    SliceTypeName[SliceTypeName["ins"] = -23] = "ins";
    SliceTypeName[SliceTypeName["sup"] = -24] = "sup";
    SliceTypeName[SliceTypeName["sub"] = -25] = "sub";
    SliceTypeName[SliceTypeName["script"] = -26] = "script";
    SliceTypeName[SliceTypeName["math"] = -27] = "math";
    SliceTypeName[SliceTypeName["font"] = -28] = "font";
    SliceTypeName[SliceTypeName["col"] = -29] = "col";
    SliceTypeName[SliceTypeName["color"] = -30] = "color";
    SliceTypeName[SliceTypeName["bg"] = -31] = "bg";
    SliceTypeName[SliceTypeName["background"] = -32] = "background";
    SliceTypeName[SliceTypeName["kbd"] = -33] = "kbd";
    SliceTypeName[SliceTypeName["spoiler"] = -34] = "spoiler";
    SliceTypeName[SliceTypeName["q"] = -35] = "q";
    SliceTypeName[SliceTypeName["cite"] = -36] = "cite";
    SliceTypeName[SliceTypeName["footnote"] = -37] = "footnote";
    SliceTypeName[SliceTypeName["ref"] = -38] = "ref";
    SliceTypeName[SliceTypeName["iaside"] = -39] = "iaside";
    SliceTypeName[SliceTypeName["iembed"] = -40] = "iembed";
    SliceTypeName[SliceTypeName["bookmark"] = -41] = "bookmark";
})(SliceTypeName || (exports.SliceTypeName = SliceTypeName = {}));
/** Slice header octet (8 bits) masking specification. */
var SliceHeaderMask;
(function (SliceHeaderMask) {
    /** The {@link Anchor} of the slice start {@link Point}.  */
    SliceHeaderMask[SliceHeaderMask["X1Anchor"] = 1] = "X1Anchor";
    /** The {@link Anchor} of the slice end {@link Point}.  */
    SliceHeaderMask[SliceHeaderMask["X2Anchor"] = 2] = "X2Anchor";
    /** Slice stacking behavior, one of {@link SliceStacking}. */
    SliceHeaderMask[SliceHeaderMask["Stacking"] = 28] = "Stacking";
})(SliceHeaderMask || (exports.SliceHeaderMask = SliceHeaderMask = {}));
var SliceHeaderShift;
(function (SliceHeaderShift) {
    SliceHeaderShift[SliceHeaderShift["X1Anchor"] = 0] = "X1Anchor";
    SliceHeaderShift[SliceHeaderShift["X2Anchor"] = 1] = "X2Anchor";
    SliceHeaderShift[SliceHeaderShift["Stacking"] = 2] = "Stacking";
})(SliceHeaderShift || (exports.SliceHeaderShift = SliceHeaderShift = {}));
var SliceStacking;
(function (SliceStacking) {
    /**
     * The `Marker` slices are used to mark a block split position in the
     * document. For example, paragraph, heading, blockquote, etc. It separates
     * adjacent blocks and is used to determine the block type of the contents
     * following the marker, until the next marker is encountered.
     */
    SliceStacking[SliceStacking["Marker"] = 0] = "Marker";
    /**
     * The `Many` slices are inline formatting annotations, which allow one
     * or more annotations of the same type to apply to the same text. Slices with
     * stacking behavior `Many` are appended to the stack of attributes for a
     * specific slice type. With the most recent annotation on top.
     *
     * Slices with stacking behavior `Many` are used for inline formatting, like
     * for links, comments, etc. Where multiple annotations of the same type can
     * be applied to the same text.
     */
    SliceStacking[SliceStacking["Many"] = 1] = "Many";
    /**
     * The slices with stacking behavior `One` are used for inline formatting
     * annotations, they overwrite the stack of attributes for a specific slice
     * type. This type of slice is used when only one annotation of a specific
     * type can be applied to the same text. For example, those could be used
     * for simple inline formatting, like bold, italic, etc.
     */
    SliceStacking[SliceStacking["One"] = 2] = "One";
    /**
     * The `Erase` slices are used to soft remove all annotations
     * (`Many` or `One`) of the same type which are applied to the same text
     * range. The erase slices soft remove only the annotations which were applied
     * before the erase slice, as determined by the logical clock (there could
     * be many layers of annotations applied and erased).
     *
     * Usually slices with stacking behavior `Erase` are used to reverse inline
     * exclusive (`One`) inline formatting, like bold, italic, etc.
     */
    SliceStacking[SliceStacking["Erase"] = 3] = "Erase";
    /**
     * Used to mark the user's cursor position in the document.
     */
    SliceStacking[SliceStacking["Cursor"] = 4] = "Cursor";
    /**
     * Used for inline indivisible non-editable islands, like an inline math
     * equation. The contents of the slice text can still be used for storing the
     * formula source, however, the editor navigation treats it as an atomic unit.
     * A single ArrowLeft or ArrowRight movement jumps over the whole slice, and
     * the cursor can not be placed in the middle of the slice.
     */
    SliceStacking[SliceStacking["Atomic"] = 5] = "Atomic";
})(SliceStacking || (exports.SliceStacking = SliceStacking = {}));
var SliceStackingName;
(function (SliceStackingName) {
    SliceStackingName[SliceStackingName["Marker"] = 0] = "Marker";
    SliceStackingName[SliceStackingName["Many"] = 1] = "Many";
    SliceStackingName[SliceStackingName["One"] = 2] = "One";
    SliceStackingName[SliceStackingName["Erase"] = 3] = "Erase";
    SliceStackingName[SliceStackingName["Cursor"] = 4] = "Cursor";
    SliceStackingName[SliceStackingName["Atomic"] = 5] = "Atomic";
})(SliceStackingName || (exports.SliceStackingName = SliceStackingName = {}));
/**
 * Specifies `vec` offsets in the {@link SliceView}.
 */
var SliceTupleIndex;
(function (SliceTupleIndex) {
    SliceTupleIndex[SliceTupleIndex["Header"] = 0] = "Header";
    SliceTupleIndex[SliceTupleIndex["X1"] = 1] = "X1";
    SliceTupleIndex[SliceTupleIndex["X2"] = 2] = "X2";
    SliceTupleIndex[SliceTupleIndex["Type"] = 3] = "Type";
    SliceTupleIndex[SliceTupleIndex["Data"] = 4] = "Data";
})(SliceTupleIndex || (exports.SliceTupleIndex = SliceTupleIndex = {}));
